.login {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
  background-color: #021832;

  .versionInfo {
    display: block;
    width: 100%;
    color: #fff;
    font-size: 11px;
    text-align: center;
    margin-top: 10px;
  }

  .loginForm {
    width: 425px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    position: relative;

    .circularProgress {
      position: absolute;
      z-index: 99;
    }

    .loginBox {
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 6px;
      box-shadow: 0 1.5px 0 0 rgba(0, 0, 0, 0.1);
      width: 375px;
      color: #fff;
      padding: 20px;
      text-align: center;
      position: relative;

      img {
        margin-bottom: 4px;
      }

      .loginButton {
        float: right;
        margin-top: 15px;
      }

      .forgotPasswordLink {
        font-size: 9.6px;
        position: absolute;
        right: 22px;
        bottom: 138px;
        color: black;
        text-decoration: underline;
      }

      .disabledButton {
        @extend .loginButton;
        background-color: #ebebeb;
      }

      .buttonContainer {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }

      .passwordSent {
        display: block;
        color: black;
        font-size: 12px;
        padding-top: 10px;
      }

      .errorMessage {
        color: red;
        font-size: 12px;
        display: block;
        text-align: left;
      }

      .backButton {
        margin-top: 5px;
        text-decoration: none;
        text-transform: uppercase;
        color: #006da8;
      }
    }
  }
}
